import '../DeckNav.css';
import { EmotionsDeckFace } from '../../DeckCardOverviews/BasicWords/EmotionsOv';
import DeckNav from '../DeckNav';
import HeaderNav from '../../Components/Header/Header_Nav/Header_Nav';
//one folder up so use ../
//if two folders away use ../../
import SPLoader from '../../Components/Spinner/SpinnerLoader';
import ResourceBar from '../../Components/Resource/ResourceBar';
import Footer from '../../Components/Footer/Footer';


export default function EmotionsNav() {
  return (
<div>
  <SPLoader time={0.2}/>
  <HeaderNav GoBack_to={"/BasicWordsNav"}/>
  <h1 className="DeckTitle-nav">Emotions (감정)</h1>
  <ResourceBar DeeperLook_to="/EmotionsDLook" Dictionary_to="/EmotionsDictionary"/>
  <h1 className="Header2-nav">Flashcards</h1>
   <div><DeckNav faceCard={EmotionsDeckFace} title_input=""/> </div>
   <Footer/>
</div>
  )
}